import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo">
          <h3>The Clean Knight Co.</h3>
          <p>Professional exterior house cleaning services that make your property shine. Eco-friendly solutions, experienced team, and exceptional results guaranteed.</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#testimonials">Testimonials</a></li>
            <li><a href="#faq">FAQ</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Services</h4>
          <ul>
            <li><Link to="/services/driveway-washing">Driveway Washing</Link></li>
            <li><Link to="/services/patio-cleaning">Patio Cleaning</Link></li>
            <li><Link to="/services/gutter-cleaning">Gutter Cleaning</Link></li>
            <li><Link to="/services/roof-cleaning">Roof Cleaning</Link></li>
            <li><Link to="/services/solar-panel-cleaning">Solar Panel Cleaning</Link></li>
            <li><Link to="/services/residential-cleaning">Residential and Commercial Cleaning</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h4>Connect With Us</h4>
          <ul>
            <li><a href="https://www.facebook.com/profile.php?id=61578825262959" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="https://www.instagram.com/the_clean_knight?igsh=MWg2ZG55eTJkODk0OA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            {/* <li><a href="#" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="#" target="_blank" rel="noopener noreferrer">LinkedIn</a></li> */}
          </ul>
        </div>
      </div>

      <div className="copyright">
        <p>&copy; {currentYear} The Clean Knight Co. Exterior Cleaning Services. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
// /**
//  * Footer Component
//  * Renders the website footer
//  */

// const Footer = {
//   render: (currentYear = new Date().getFullYear()) => {
//     return `
//       <footer>
//         <div class="footer-content">
//           <div class="footer-logo">
//             <h3>The Clean Knight Co.</h3>
//             <p>Professional exterior house cleaning services that make your property shine. Eco-friendly solutions, experienced team, and exceptional results guaranteed.</p>
//           </div>

//           <div class="footer-links">
//             <h4>Quick Links</h4>
//             <ul>
//               <li><a href="#home">Home</a></li>
//               <li><a href="#services">Services</a></li>
//               <li><a href="#about">About Us</a></li>
//               <li><a href="#testimonials">Testimonials</a></li>
//               <li><a href="#faq">FAQ</a></li>
//               <li><a href="#contact">Contact</a></li>
//             </ul>
//           </div>

//           <div class="footer-links">
//             <h4>Services</h4>
//             <ul>
//               <li><a href="#services">Driveway Washing</a></li>
//               <li><a href="#services">Patio Cleaning</a></li>
//               <li><a href="#services">Gutter Cleaning</a></li>
//               <li><a href="#services">Roof Cleaning</a></li>
//               <li><a href="#services">Solar Panel Cleaning</a></li>
//             </ul>
//           </div>

//           <div class="footer-links">
//             <h4>Connect With Us</h4>
//             <ul>
//               <li><a href="#" target="_blank" rel="noopener noreferrer">Facebook</a></li>
//               <li><a href="#" target="_blank" rel="noopener noreferrer">Instagram</a></li>
//               <li><a href="#" target="_blank" rel="noopener noreferrer">Twitter</a></li>
//               <li><a href="#" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
//             </ul>
//           </div>
//         </div>

//         <div class="copyright">
//           <p>&copy; ${currentYear} The Clean Knight Co. Exterior Cleaning Services. All rights reserved.</p>
//         </div>
//       </footer>
//     `;
//   },

//   setup: () => {
//     // Any specific setup for the footer can be added here
//     // This could include things like back-to-top buttons, etc.
//   }
// };

// export default Footer;